import { CService } from "./class.base.service";

class FundTypeService extends CService {}

const fundTypeService = new FundTypeService("fund-types")
export default fundTypeService